module.exports = ['$scope', 'ngMeta', '$state', '$transitions', function ($scope, ngMeta, $state, $transitions) {
  'use strict';
  $scope.stateIncludes = $state.includes;

  $transitions.onStart({}, function (){
    $scope.extraBreadcrumb = '';
  });

}];


// WEBPACK FOOTER //
// ./web/js/screen/concept/conceptController.js